/** Schedule day accordion list width within the batches settings section. */
export const scheduleDayRowsSx = {
  maxWidth: "75%",
  width: "100%"
} as const;

export const scheduleDayAccordionSx = {
  border: 1,
  borderColor: "divider",
  borderRadius: 1,
  mb: 1,
  "&:before": { display: "none" },
  "&.Mui-expanded": { mb: 1 },
  boxShadow: "none",
  bgcolor: "common.white",
  "&:hover": {
    bgcolor: "common.white"
  },
  "& .MuiAccordionSummary-root, & .MuiAccordionDetails-root": {
    bgcolor: "common.white"
  }
} as const;

export const scheduleEntryCardSx = {
  flex: 1,
  minWidth: 0,
  border: 1,
  borderColor: "divider",
  borderRadius: 1,
  bgcolor: "common.white"
} as const;
